import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import { ReactComponent as MailIcon } from "./IconMail.svg";
import { ReactComponent as PhoneIcon } from "./IconPhone.svg";

import { Link } from "react-router-dom";
import { blueBorder, footerColor } from "../../Classes/theme";

const NavIcon = ({ icon }) => {
  const editedIcon = React.cloneElement(icon, {
    style: {
      maxHeight: "15px",
      width: "15px",
    },
  });
  return <>{editedIcon}</>;
};

export const extendedNavigation = [
  {
    title: "Doprava",
    nav: [
      {
        name: "Zkouška autoškola",
        path: "https://appliner.cz/autoskola",
      },
      {
        name: "Profesní průkaz",
        path: "https://appliner.cz/profesak",
      },
    ],
  },
  {
    title: "Státní sektor",
    nav: [
      //{ name: "Úřednická zkouška", path: "https://appliner.cz/urednik" },
      { name: "Zkouška strážníka", path: "https://appliner.cz/straznik" },
    ],
  },
  {
    title: "Rekreace",
    nav: [
      {
        name: "Zbrojní průkaz",
        path: "https://appliner.cz/zbrojak",
      },
      {
        name: "Zkouška rybáře",
        path: "https://appliner.cz/rybar",
      },
    ],
  },
  {
    title: "Kontakt",
    nav: [
      {
        name: "info@metastream.cz",
        path: "mailto:info@metastream.cz",
        icon: <NavIcon icon={<MailIcon />} />,
      },
      {
        name: "797 996 873",
        path: "tel:+420737972674",
        icon: <NavIcon icon={<PhoneIcon />} />,
      }

    ],
  },
];

export default function FooterExtension() {
  const [move, setMove] = useState(null);
  return (
    <div>
      <Box sx={{ minHeight: "280px", bgcolor: footerColor }}>
        <Container
          maxWidth="lg"
          sx={{
            pb: { xs: "40px", sm: "40px", md: "20px" },
            pr: "0px !important",
          }}
        >
          <Grid
            container
            columns={24}
            sx={{
              pt: { xs: "50px", sm: "50px", md: "80px" }, pl: "20px",
              width: '100%', minWidth: '100%',
              display: 'flex',
              justifyContent: "center",
              alignItems: "stretch",
            }}


          >
            {extendedNavigation.map((navData, i) => (
              <Grid
                key={"GridItem" + i}
                size={6}

                sx={{ flex: '1' }}
                columns={24}
              >
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minWidth: '100%' }}>
                  <Typography
                    sx={{
                      textAlign: "left",
                      color: "white",
                      fontWeight: 'bold',
                      mb: "30px",
                      pt: { xs: "60px", sm: "60px", md: "30px" },
                    }}
                  >
                    {navData.title}
                  </Typography>
                  {navData.nav.map((navLinks, j) => (
                    <Box
                      key={"NavDataBox" + j}
                      sx={{ display: "flex", flexDirection: "row", mb: "14px" }}
                    >
                      <Box
                        component={Link}
                        to={navLinks.path}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          alignContent: "center",
                          width: "100%",
                          mr: { xs: "33px", sm: "60px" },
                          textDecoration: "none",
                        }}
                        onMouseEnter={() => {
                          setMove({ i, j });
                        }}
                        onMouseLeave={() => {
                          if (move?.i === i && move?.j === j) {
                            setMove(null);
                          }
                        }}
                      >
                        {navLinks.icon && (
                          <div
                            style={{
                              marginRight: "20px",
                              height: "20px",
                            }}
                          >
                            {navLinks.icon}
                          </div>
                        )}
                        <Typography
                          sx={{
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            textAlign: "left",
                            color: "#E8E8E8",
                            "&:hover": {
                              color: "white",
                            },
                            width: "fit-content",
                            transition: "transform 0.2s ease",
                            transform:
                              move?.i === i && move?.j === j
                                ? "translateX(5px)"
                                : "translateX(0px)",
                          }}
                        >
                          {navLinks.name}
                        </Typography>
                        <Box sx={{ ml: "auto", pl: "3px" }}>
                          <ArrowForwardIosRoundedIcon
                            sx={{ maxHeight: "10px", color: blueBorder }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <div style={{ width: "100%", height: "1px", backgroundColor: "grey" }} />
    </div>
  );
}
